import React, { SyntheticEvent } from 'react'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from '../../form-fields/upload/field-instructions'
import Title from '../../form-fields/upload/field-title'

type Props = {
    className?: string
    field: CreationToolUploadField
    username?: string
    showInstructions?: boolean
    onChange: (username: string) => void
}

const CreationUsernameField = ({ className, field, username, showInstructions = false, onChange }: Props) => {
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLInputElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <input
                {...{
                    defaultValue: username,
                    type: 'text',
                    maxLength: maxLength || undefined,
                    placeholder,
                    onInput,
                }}
            />
            {showInstructions && <Instructions field={field} />}
        </UploadFieldBlock>
    )
}

export default CreationUsernameField
